"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_native_1 = require("react-native");
const colors_1 = __importDefault(require("../../../styles/colors"));
const styles = react_native_1.StyleSheet.create({
    loanIdStyle: {
        fontFamily: 'Noto Sans',
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontSize: 14,
        lineHeight: 21,
        color: colors_1.default.FONT_GRAY,
        margin: 10,
    },
    container: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-start',
        paddingHorizontal: 3,
        paddingVertical: 10,
        backgroundColor: colors_1.default.GRAY_CONTAINER_COLOR,
        borderRadius: 14,
    },
});
exports.default = styles;
